import React from "react";
import { Props } from "./types";

import avi from "./assets/avi.svg";
import doc from "./assets/doc.svg";
import docx from "./assets/docx.svg";
import gif from "./assets/gif.svg";
import jpg from "./assets/jpg.svg";
import mov from "./assets/mov.svg";
import mp3 from "./assets/mp3.svg";
import pdf from "./assets/pdf.svg";
import png from "./assets/png.svg";
import ppt from "./assets/ppt.svg";
import pptx from "./assets/pptx.svg";
import rar from "./assets/rar.svg";
import txt from "./assets/txt.svg";
import xls from "./assets/xls.svg";
import xlsx from "./assets/xlsx.svg";
import zip from "./assets/zip.svg";

const mimeTypeMap = {
  "video/x-msvideo": avi,
  "application/msword": doc,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    docx,
  "image/gif": gif,
  "image/jpeg": jpg,
  "video/quicktime": mov,
  "audio/mpeg3": mp3,
  "audio/x-mpeg-3": mp3,
  "video/mpeg": mp3,
  "video/x-mpeg": mp3,
  "application/pdf": pdf,
  "image/png": png,
  "application/mspowerpoint": ppt,
  "application/powerpoint": ppt,
  "application/vnd.ms-powerpoint": ppt,
  "application/x-mspowerpoint": ppt,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    pptx,
  "application/vnd.rar": rar,
  "text/plain": txt,
  "image/xls": xls,
  "application/excel": xls,
  "application/vnd.ms-excel": xls,
  "application/x-excel": xls,
  "application/x-msexcel": xls,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": xlsx,
  "application/x-compressed": zip,
  "application/x-zip-compressed": zip,
  "application/zip": zip,
  "multipart/x-zip": zip,
  "application/x-gzip": zip,
  "multipart/x-gzip": zip,
};

function getIcon(mimeType: string) {
  return mimeTypeMap[mimeType as keyof typeof mimeTypeMap] || txt;
}

function DocumentIcon(props: Props) {
  return (
    <img
      src={getIcon(props.mimeType)}
      className={props.className}
      style={props.style}
    />
  );
}

export { DocumentIcon };
